module.exports = __webpack_public_path__ + "static/media/banner-photo526.9233c4b3.jpg";